export default __webpack_public_path__ + "0821c66850a6768faa17fad2189fb774.jpg";